import React from "react";
import PropTypes from "prop-types";
import AuthorizationWrapper from "../AuthorizationWrapper";
import { DropzoneArea } from "material-ui-dropzone";
import { makeStyles } from "@material-ui/core/styles";
import swal from "sweetalert";
import { useDialog } from "../Dialogs/DialogProvider";
import DialogImage from "../Dialogs/DialogImage";
import DeleteIcon from "@material-ui/icons/Delete";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    minWidth: "100px",
    minHeight: "auto",
  },
}));

function EditImage(props) {
  const classes = useStyles();

  const [openDialog] = useDialog();
  const [imagePath, setImagePath] = React.useState(props.prefix + props.value);

  const removeImage = () => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this image!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        props.onRemove(setImagePath);
      }
    });
  };

  const save = (files) => {
    if (!files || files.length === 0) {
      return;
    }
    props.onSave(files[0], setImagePath);
  };

  return (
    <AuthorizationWrapper
      permission={props.authorizationField}
      child={(write) => {
        return (
          <div
            style={{
              textAlign: "center",
              padding: 5,
              border: "1px solid lightgrey",
              borderRadius: "5px",
              maxWidth: "200px",
              maxHeight: "200px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            {(props.value != null || imagePath != null) && (
              <img
                onClick={() => {
                  openDialog({
                    children: (
                      <DialogImage imageUrl={imagePath}>
                        {!props.disabled && write && (
                          <Button color="secondary" startIcon={<DeleteIcon />} onClick={removeImage}>
                            {"Remove image"}
                          </Button>
                        )}
                      </DialogImage>
                    ),
                  });
                }}
                style={{ objectFit: "cover", flex: "1 1 0%", height: 0, width: "100%" }}
                src={imagePath}
                alt=""
              />
            )}
            {props.value == null && imagePath == null && <Typography>No image</Typography>}
            {!props.disabled && write && (
              <DropzoneArea
                classes={{ root: classes.root }}
                filesLimit={1}
                acceptedFiles={["image/jpg", "image/png", "image/jpeg"]}
                maxFileSize={10000000}
                onDrop={(files) => save(files)}
                showPreviewsInDropzone={false}
                showPreviews={false}
                dropzoneText={""}
                previewGridProps={{ container: { spacing: 0, direction: "row" }, item: { xs: 12 } }}
              />
            )}
          </div>
        );
      }}
    />
  );
}

EditImage.propTypes = {
  authorizationField: PropTypes.string.isRequired,
  value: PropTypes.string,
  prefix: PropTypes.string,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
};

export default EditImage;
